import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=9b551116&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=9b551116&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b551116",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b551116')) {
      api.createRecord('9b551116', component.options)
    } else {
      api.reload('9b551116', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=9b551116&scoped=true", function () {
      api.rerender('9b551116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referralValidity/Main.vue"
export default component.exports